import thunk from "redux-thunk";
import { compose, createStore, applyMiddleware } from "redux";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { sortBy } from "lodash";

import reducers from "../reducers";
import { tabColor, tabTextColor } from "../constants/Colors";
import { isWeb } from "../constants/Config";

const persistConfig = {
  key: "tabmemo",
  storage,
  blacklist: ["common"],
};

if (isWeb) {
  persistConfig.blacklist = ["categories", "memos", "common"];
}

const persistedReducer = persistReducer(persistConfig, reducers);
const store = createStore(
  persistedReducer,
  {},
  compose(applyMiddleware(thunk))
);

export const persistor = persistStore(store);

export const getTabColor = (catId: string) => {
  const { categories } = store.getState();
  return (
    tabColor[categories.order.indexOf(catId) % tabColor.length] || tabColor[0]
  );
};

export const getTabTextColor = (catId: string) => {
  const { categories } = store.getState();
  return (
    tabTextColor[categories.order.indexOf(catId) % tabTextColor.length] ||
    tabTextColor[0]
  );
};

export const getCatName = (catId: string) => {
  const { categories } = store.getState();
  if (!catId || !Object.keys(categories.list).includes(catId)) {
    return "";
  }
  return categories.list[catId].name;
};

export const getFilterdMemos = (catId: string) => {
  const { memos } = store.getState();
  if (catId) {
    return sortBy(
      Object.keys(memos)
        .map(key => ({ ...memos[key], id: key }))
        .filter(memo => memo.cat.includes(catId)),
      memo => new Date(memo._modifiedAt)
    ).reverse();
  } else {
    // ゴミ箱
    return sortBy(
      Object.keys(memos)
        .map(key => ({ ...memos[key], id: key }))
        .filter(memo => !memo.cat.length),
      memo => new Date(memo._modifiedAt)
    ).reverse();
  }
};

export default store;
